import {
  FiPackage,
  FaRegListAlt,
  FaIdCard,
  FiHome,
  GrMoney,
  GrTemplate,
  SiSemanticweb,
  GrConnect,
  AiOutlinePartition,
  BiUserPlus,
  RiCustomerService2Line,
} from 'react-icons/all';

import HomePage from '../components/home-page';
import ProfilePage from '../components/profile';
import SettingsPage from '../components/settings';
import DigiCardSitePage from '../components/products/digi-card/site-page';
import DigiCardTemplatesPage from '../components/products/digi-card/templates-page';
import DistributorPage from '../components/distributor-chain/distributor-page';
import AddDistributorPage from '../components/distributor-chain/add-distributor';
import DistributorPlanPage from '../components/distributor-chain/plan-page';
import DistributorPaymentsPage from '../components/distributor-chain/payments-page';
import MerchantUsersPage from '../components/users/users-page';
import AddUserPage from '../components/users/add-user-page';
import MerchantPlanPage from '../components/users/plan-page';
import MerchantPaymentsPage from '../components/users/payments-page';
import SupportUsersPage from '../components/support-users/support-users-page';
import AddSupportUserPage from '../components/support-users/add-support-user';

export const routes = [
  { title: 'Home', icon: FiHome, to: '/home', component: <HomePage />, placement: 'top' },
  { title: 'Profile', icon: FaIdCard, to: '/profile', component: <ProfilePage />, placement: 'bottom' },
  { title: 'Settings', icon: FaRegListAlt, to: '/settings', component: <SettingsPage />, placement: 'bottom' },
  {
    title: 'Products',
    icon: FaRegListAlt,
    placement: 'top',
    items: [
      /*{
        title: 'Auto SMS', icon: MdSms, items: [
          { title: 'Plans', icon: FiPackage, to: '/auto-sms/plans', component: <AutoSMSPlanPage/> },
          { title: 'Users', icon: FiUsers, to: '/auto-sms/users', component: <AutoSMSUsersPage/> },
          { title: 'Payments', icon: GrMoney, to: '/auto-sms/payments', component: <AutoSMSPaymentsPage/> },
        ]
      },*/
      {
        title: 'Digi Card',
        icon: FaIdCard,
        items: [
          {
            title: 'Sites',
            icon: SiSemanticweb,
            to: '/digi-card/sites',
            component: <DigiCardSitePage />,
          },
          {
            title: 'Templates',
            icon: GrTemplate,
            to: '/digi-card/templates',
            component: <DigiCardTemplatesPage />,
          },
        ],
      },
    ],
  },
  {
    title: 'Distributor Chain',
    icon: GrConnect,
    placement: 'top',
    items: [
      {
        title: 'Distributors',
        icon: AiOutlinePartition,
        to: '/distributors',
        component: <DistributorPage />,
      },
      {
        title: 'Add Distributor',
        icon: BiUserPlus,
        to: '/distributors/add',
        component: <AddDistributorPage />,
      },
      {
        title: 'Distributor Plans',
        icon: FiPackage,
        to: '/distributors/plans',
        component: <DistributorPlanPage />,
      },
      {
        title: 'Distributor Payments',
        icon: GrMoney,
        to: '/distributors/payments',
        component: <DistributorPaymentsPage />,
      },
    ],
  },
  {
    title: 'Merchant Details',
    icon: AiOutlinePartition,
    placement: 'top',
    items: [
      {
        title: 'Merchants',
        icon: AiOutlinePartition,
        to: '/merchants',
        component: <MerchantUsersPage />,
      },
      {
        title: 'Add Merchant',
        icon: BiUserPlus,
        to: '/merchants/add',
        component: <AddUserPage />,
      },
      {
        title: 'Merchant Plans',
        icon: FiPackage,
        to: '/merchants/plans',
        component: <MerchantPlanPage />,
      },
      {
        title: 'Merchant Payments',
        icon: GrMoney,
        to: '/merchants/payments',
        component: <MerchantPaymentsPage />,
      },
    ],
  },
  {
    title: 'Support Users',
    icon: RiCustomerService2Line,
    placement: 'top',
    items: [
      {
        title: 'Support Users',
        icon: RiCustomerService2Line,
        to: '/support-users',
        component: <SupportUsersPage />,
      },
      {
        title: 'Add Support User',
        icon: BiUserPlus,
        to: '/support-users/add',
        component: <AddSupportUserPage />,
      },
    ],
  },
];
